import { USER_API_URLS } from '@/config/apiConfig';
import {
  RegisterUserPayload,
  RegisterUserResponse,
  VerifyOtpResponse,
  GetAllUsersResponse,
  GetAllActivityLogsResponse,
} from '@/types/user';

export interface RoleProfile {
  name: string;
}

// Helper function to get auth token
const getAuthToken = (): string => {
  if (typeof window === 'undefined') return '';
  const token = localStorage.getItem('token');
  return token || '';
};

// Send OTP
export const sendOtp = async (phoneNumber: string) => {
  const response = await fetch(USER_API_URLS.SEND_OTP, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ phoneno: phoneNumber }),
  });

  if (!response.ok) throw new Error('Failed to send OTP');

  const data = await response.json();
  return data.data;
};

// Verify OTP
export const verifyOtp = async (phoneNumber: string, code: string) => {
  const response = await fetch(USER_API_URLS.VERIFY_OTP, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ phoneno: phoneNumber, code: code }),
  });

  if (!response.ok) throw new Error('Failed to verify OTP');

  const data: VerifyOtpResponse = await response.json();
  console.log('data', data);
  return data.data;
};

// Register User
export const registerUser = async (userData: RegisterUserPayload) => {
  const response = await fetch(USER_API_URLS.REGISTER_USER, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) throw new Error('Failed to register user');

  const data: RegisterUserResponse = await response.json();
  console.log('data register user', data);
  return data.data;
};

// Get All Users
export const getAllUsers = async () => {
  const token = getAuthToken();
  const response = await fetch(USER_API_URLS.GET_ALL_USERS, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  });

  if (!response.ok) throw new Error('Failed to get all users');

  const data: GetAllUsersResponse = await response.json();
  
  return data.data;
};

// Create User
export const createUser = async (userData: any) => {
  const token = getAuthToken();
  const response = await fetch(USER_API_URLS.CREATE_USER, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) throw new Error('Failed to create user');

  const data: any = await response.json();
  return data.data;
};

// Update User
export const updateUser = async (userId: string, userData: any) => {
  const token = getAuthToken();
  const url = USER_API_URLS.UPDATE_USER.replace(':id', userId);
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) throw new Error('Failed to update user');

  const data: any = await response.json();
  return data.data;
};

// Delete User
export const deleteUser = async (userId: string) => {
  const token = getAuthToken();
  const url = USER_API_URLS.DELETE_USER.replace(':id', userId);
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  });

  if (!response.ok) throw new Error('Failed to delete user');

  const data: any = await response.json();
  return data;
};

// Get User By ID
export const getUserById = async (userId: string) => {
  const token = getAuthToken();
  const url = USER_API_URLS.GET_USER_BY_ID.replace(':id', userId);
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  });

  if (!response.ok) throw new Error('Failed to get user by id');

  const data: any = await response.json();
  return data.data;
};

// Get All Activity Logs
export const getAllActivityLogs = async () => {
  const token = getAuthToken();
  const response = await fetch(USER_API_URLS.GET_ALL_ACTIVITY_LOGS, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  });

  if (!response.ok) throw new Error('Failed to get all activity logs');

  const data: GetAllActivityLogsResponse = await response.json();
  return data.data;
};
